export const update = (target, source) => {
  return Object.assign(Object.create(Object.getPrototypeOf(target)), target, source);
};
